import { useEffect, useState } from "react";
import { FileText } from "lucide-react";
import { toast } from "sonner";
import { api, formatApiErrorDetail } from "@/lib/api";

export function ChequeActions({ order, onDone }) {
  const [busy, setBusy] = useState(false);
  const act = async (path, confirmText) => {
    if (!window.confirm(confirmText)) return;
    setBusy(true);
    try {
      const { data } = await api.post(`/admin/orders/${order.session_id}/${path}`);
      toast.success(data.message);
      onDone();
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail) || "Action impossible");
    } finally {
      setBusy(false);
    }
  };
  return (
    <>
      <button data-testid={`order-cheque-received-${order.session_id}`} disabled={busy} onClick={() => act("cheque-received", "Confirmer l'encaissement du chèque ? La commande passera en « Payée ».")} className="rounded-full border border-sage/40 bg-sage-light px-3 py-1 text-xs font-medium text-sage transition-colors hover:bg-sage/20 disabled:opacity-50">
        Chèque encaissé
      </button>
    </>
  );
}

export function ChequeSettingsCard() {
  const [form, setForm] = useState(null);
  const [saving, setSaving] = useState(false);
  useEffect(() => { api.get("/payments/cheque-settings").then(({ data }) => setForm(data)).catch(() => {}); }, []);
  if (!form) return null;

  const save = async (e) => {
    e.preventDefault();
    setSaving(true);
    try {
      const { data } = await api.put("/admin/cheque-settings", { enabled: form.enabled, payee: form.payee, address: form.address });
      setForm(data);
      toast.success("Paiement par chèque mis à jour");
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail) || "Enregistrement impossible");
    } finally {
      setSaving(false);
    }
  };
  const field = "mt-1 w-full rounded-xl border border-amber-900/20 bg-cream px-4 py-2.5 text-sm outline-none focus:border-amber-deep";
  return (
    <form data-testid="cheque-settings-form" onSubmit={save} className="rounded-2xl border border-amber-800/15 bg-white p-6 shadow-sm">
      <div className="flex flex-wrap items-center justify-between gap-3">
        <h2 className="flex items-center gap-2 font-serif text-xl font-semibold text-bark"><FileText size={18} className="text-honey" /> Paiement par chèque</h2>
        <label className="flex items-center gap-2 text-sm font-medium text-bark">
          <input data-testid="cheque-enabled" type="checkbox" checked={form.enabled} onChange={(e) => setForm({ ...form, enabled: e.target.checked })} className="h-4 w-4 accent-amber-deep" /> Proposé aux clients
        </label>
      </div>
      <p className="mt-1 text-sm text-bark-soft">Réservé aux résidents en France. Message affiché : « {form.message} »</p>
      <div className="mt-4 grid gap-4 sm:grid-cols-2">
        <label className="text-sm font-medium text-bark">Ordre du chèque
          <input data-testid="cheque-payee" value={form.payee} onChange={(e) => setForm({ ...form, payee: e.target.value })} className={field} />
        </label>
        <label className="text-sm font-medium text-bark">Adresse d'envoi des chèques
          <textarea data-testid="cheque-address-input" rows={3} value={form.address} onChange={(e) => setForm({ ...form, address: e.target.value })} placeholder={"Pétales de Miel\n12 chemin des Ruches\n26000 Valence"} className={field} />
        </label>
      </div>
      <button data-testid="cheque-settings-save" disabled={saving} className="mt-4 rounded-full bg-amber-deep px-6 py-2.5 text-sm font-semibold text-white transition-colors hover:bg-honey disabled:opacity-60">
        {saving ? "Enregistrement…" : "Enregistrer"}
      </button>
    </form>
  );
}
